import { MD5Algo } from 'crypto-es/lib/md5.js'

const userAgent = window.navigator.userAgent
let seq = Math.floor(Math.random() * Math.floor(4294967295))
const md5Sum = MD5Algo.create().update(userAgent).finalize()

// 兼容性函数：设置64位大端序整数
function setBigUint64Compatible(dataView: DataView, byteOffset: number, value: bigint) {
  if (typeof dataView.setBigUint64 === 'function') {
    // 如果浏览器支持setBigUint64，直接使用原生方法
    dataView.setBigUint64(byteOffset, value)
  } else {
    // 手动处理64位整数，使用更安全的方式
    // 使用BigInt.asUintN确保数值在正确范围内
    const high = Number(BigInt.asUintN(64, value) >> 32n)
    const low = Number(BigInt.asUintN(32, value))

    // 以大端序方式写入（与原始setBigUint64默认行为一致）
    dataView.setUint32(byteOffset, high)
    dataView.setUint32(byteOffset + 4, low)
  }
}

function createTraceID() {
  const traceID = new Uint8Array(16)

  traceID.set(md5Sum.words.slice(0, 4), 0) // Copy first 4 bytes of md5Sum to traceID

  const now = BigInt(Date.now()) * BigInt(1000000) // Convert current time to nanoseconds
  const timeBuffer = new ArrayBuffer(8)
  const dataView = new DataView(timeBuffer)
  setBigUint64Compatible(dataView, 0, now)
  traceID.set(new Uint8Array(timeBuffer), 4) // Set next 8 bytes of traceID with current time

  // Set last 4 bytes with sequence number
  traceID.set(new Uint8Array(new Uint32Array([seq++]).buffer), 12)

  const str = traceID.reduce((acc, byte) => acc + byte.toString(16).padStart(2, '0'), '')

  return str
}

export { createTraceID }
